<script>
import {
  iFeaturedIcon,
  iFeaturedIconTypes,
  iFeaturedIconSizes,
  iIconButton,
} from '@inscribe/signal';

export default {
  name: 'signal-button',
  components: {
    iIconButton,
    iFeaturedIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    success: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      iFeaturedIconTypes,
      iFeaturedIconSizes,
    };
  },
  computed: {
    hasToolsSlot() {
      return !!this.$slots.tools;
    },
  },
  methods: {
    onButtonClick() {
      this.$emit('button-click');
    },
    onMouseOver() {
      this.$emit('mouse-over');
    },
    onMouseLeave() {
      this.$emit('mouse-leave');
    },
  },
};
</script>

<template>
  <button
    data-testid="signal-button"
    class="signal-button d-flex flex-row justify-content-start align-items-center i-px-6 i-py-5 i-gap-6 i-radius-xl"
    @click="onButtonClick"
    @mouseover="onMouseOver"
    @mouseleave="onMouseLeave"
  >
    <i-featured-icon
      :size="iFeaturedIconSizes.SM"
      :type="success ? iFeaturedIconTypes.SUCCESS : iFeaturedIconTypes.ERROR"
      :symbol="success ? 'small-check-1' : 'small-alert-triangle'"
      :class="{ passed: success, failed: !success }"
      class="signal-icon"
    ></i-featured-icon>
    <div class="text d-flex flex-column align-items-start flex-grow-1 i-gap-1">
      <div class="title i-text-button-3 i-text-neutral-120">
        {{ title }}
      </div>
      <div class="subtitle i-text-body-3 i-text-neutral-110">
        {{ subtitle }}
      </div>
    </div>
    <div v-if="hasToolsSlot" class="tools on-hover-content">
      <slot name="tools"></slot>
    </div>
    <i-icon-button
      v-else
      class="link-icon on-hover-content"
      symbol="medium-chevron-right"
      size="md"
      type="transparent"
      @button-click="onButtonClick"
    ></i-icon-button>
  </button>
</template>

<style scoped lang="scss">
.signal-button {
  background: $light-neutral-default;
  width: 100%;
  border: 0;
  outline: 0;
  transition: background-color 150ms ease-in-out;

  .signal-icon {
    min-width: 36px;
    transition: background-color 150ms ease-in-out;
  }

  .on-hover-content {
    opacity: 0;
    transition: opacity 150ms ease-in-out;
    pointer-events: none;
  }

  .text {
    max-width: 340px;

    .title,
    .subtitle {
      text-align: left;
    }
  }

  .tools {
    position: absolute;
    right: 0;
    background: $light-neutral-20;
  }

  &:hover {
    background: $light-neutral-20;

    .signal-icon {
      &.passed {
        background: $light-success-40 !important;
      }

      &.failed {
        background: $light-error-40 !important;
      }
    }

    .on-hover-content {
      opacity: 1;
      pointer-events: initial;
    }
  }
}
</style>
